import { Pipe, PipeTransform } from "@angular/core";
import { AllAddressType } from "../../../../common/services/api/resources/addressSummary/address-summary";

@Pipe({
  name: "singularAddressType",
  standalone: false
})
export class FormatSingularAddressTypePipe implements PipeTransform {
  private addressTypeMap: { [K in AllAddressType]?: string } = {
    adv_voicemailbox: "Voice Mailbox",
    adv_queue: "ACD Queue",
    adv_park: "Parking Lot",
    adv_attendant_menu: "Attendant Menu",
    adv_dbn_directory: "Dial-by-name directory",
    adv_announcement: "Announcement",
    telephone_number: "External Phone Number",
    external: "External SIP Address",
    group: "Group",
    user: "User",
    time_switch: "Business Hour Rule",
    contact_center: "Contact Center",
    voicemail_management: "Voicemail Manager",
    recording_management: "Recording Manager",
    e911: "911 Emergency",
    adv_moh: "Music On Hold",
    adv_queue_login: "ACD Queue Login",
    adv_park_retriever: "Parking Lot Retrieval",
    inbound_bridge: "Inbound Bridge",
    conference_bridge: "On Net Conference Suite"
  };
  transform(address: AllAddressType): string {
    return this.addressTypeMap[address] || address;
  }
}
